namespace $ {

	type $shm_hitalama_compat_fqn_storage = {
		readonly length: number
		key( index: number ): string | null
		getItem( key: string ): string | null
		setItem( key: string, value: string ): void
	}

	const $shm_hitalama_compat_fqn_done = new WeakMap< object, Set< string > >
	const $shm_hitalama_compat_fqn_storage_done = new WeakSet< object >
	const $shm_hitalama_compat_fqn_prefixes = [
		{ current: '$shm_ba_', legacy: [ '$' + 'hitalama_ba_', '$shm_hitalama_ba_' ] },
		{ current: '$shm_wordstat_', legacy: [ '$' + 'hitalama_wordstat_', '$shm_hitalama_wordstat_' ] },
		{ current: '$shm_mentionstat_', legacy: [ '$' + 'hitalama_mentionstat_', '$shm_hitalama_mentionstat_' ] },
		{ current: '$shm_codex_', legacy: [ '$' + 'hitalama_codex_', '$shm_hitalama_codex_' ] },
		{ current: '$shm_hitalama_', legacy: [ '$' + 'hitalama_' ] },
	] as const

	function $shm_hitalama_compat_fqn_current( name: string ) {
		for( const mapping of $shm_hitalama_compat_fqn_prefixes ) {
			for( const legacy of mapping.legacy ) {
				if( name.startsWith( legacy ) ) return mapping.current + name.slice( legacy.length )
			}
		}
		return name
	}

	function $shm_hitalama_compat_fqn_storage_migrate( storage: $shm_hitalama_compat_fqn_storage | undefined ) {
		if( !storage || $shm_hitalama_compat_fqn_storage_done.has( storage ) ) return
		$shm_hitalama_compat_fqn_storage_done.add( storage )

		const keys = Array.from({ length: storage.length }, ( _, index )=> storage.key( index ) )
		for( const old_key of keys ) {
			if( !old_key ) continue
			const new_key = $shm_hitalama_compat_fqn_current( old_key )
			if( new_key === old_key ) continue
			if( storage.getItem( new_key ) !== null ) continue
			const value = storage.getItem( old_key )
			if( value !== null ) storage.setItem( new_key, value )
		}
	}

	export function $shm_hitalama_compat_fqn_install( context: Record< string, any > = $ as any ) {
		let done = $shm_hitalama_compat_fqn_done.get( context )
		if( !done ) $shm_hitalama_compat_fqn_done.set( context, done = new Set )

		for( const name of Object.keys( context ) ) {
			if( done.has( name ) ) continue
			const mapping = $shm_hitalama_compat_fqn_prefixes.find( mapping => name.startsWith( mapping.current ) )
			if( !mapping ) continue

			for( const prefix of mapping.legacy ) {
				const legacy = prefix + name.slice( mapping.current.length )
				if( legacy in context ) continue
				Object.defineProperty( context, legacy, {
					configurable: true,
					get: ()=> context[ name ],
					set: value => context[ name ] = value,
				} )
			}
			done.add( name )
		}

		const dom = globalThis as any
		$shm_hitalama_compat_fqn_storage_migrate( dom.localStorage )
		$shm_hitalama_compat_fqn_storage_migrate( dom.sessionStorage )
	}

	export function $shm_hitalama_compat_fqn_css( code: string ) {
		const prefixes = [
			[ 'shm_hitalama_ba_', 'shm_ba_' ],
			[ 'hitalama_ba_', 'shm_ba_' ],
			[ 'shm_hitalama_wordstat_', 'shm_wordstat_' ],
			[ 'hitalama_wordstat_', 'shm_wordstat_' ],
			[ 'shm_hitalama_mentionstat_', 'shm_mentionstat_' ],
			[ 'hitalama_mentionstat_', 'shm_mentionstat_' ],
			[ 'shm_hitalama_codex_', 'shm_codex_' ],
			[ 'hitalama_codex_', 'shm_codex_' ],
			[ 'hitalama_', 'shm_hitalama_' ],
		] as const

		for( const [ from, to ] of prefixes ) {
			code = code
				.replaceAll( `[${ from }`, `[${ to }` )
				.replace( new RegExp( `(^|[\\s,>+~])${ from }(?=[\\w-])`, 'gm' ), ( _, prefix )=> prefix + to )
		}
		return code
	}

}
